import React from "react";
import { CartContext } from "./components/context";

export function useCartContextProvider() {
  const context = React.useContext(CartContext);
  if (!context) {
    throw new Error(
      "No CartContext was provided. Listbox components must be wrapped in a Listbox"
    );
  }
  return context;
}
